// extracted by mini-css-extract-plugin
export default {"container":"FullPizza_container__H7vjJ","image":"FullPizza_image__RvLL+","header":"FullPizza_header__Bpd5J","price":"FullPizza_price__PiKNv"};